import Home from "./screens/Home";
import { Routes, Route } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css"; //アイコン
import Header from "./screens/Header";
import SignIn from "./screens/SignIn";
import SignUp from "./screens/SignUp";
import { useEffect, useRef, useState } from "react";
import { db, auth } from ".";
import { onAuthStateChanged } from "firebase/auth";
import { ref, onValue, get } from "firebase/database";
import { useNavigate, useLocation } from "react-router-dom";
import Join from "./screens/Join";
import GameHome from "./screens/game/GameHome";
import EditGame from "./screens/operate/EditGame";
import Control from "./screens/operate/Control";
import Account from "./screens/account/Account";
import MapPage from "./screens/game/map/MapPage";
import Missions from "./screens/game/Missions";
import NotationsSCT from "./screens/Info/NotationsSCT";
import Info from "./screens/Info/Info";
import Footer from "./screens/Footer";
import Catch from "./screens/game/Catch";
import TeamList from "./screens/game/TeamList";
import SubmitMission from "./screens/game/SubmitMission";
import AddCoin from "./screens/account/AddCoin";
import HistoryPage from "./screens/game/HistoryPage";
import CoinHistory from "./screens/account/CoinHistory";
import MissionReport from "./screens/game/MissionReport";
import Privacy from "./screens/Info/Privacy";
import Terms from "./screens/Info/Terms";
import SpecialItems from "./screens/game/SpecialItems";
import JoinHistory from "./screens/account/JoinHistory";
import Setting from "./screens/account/Setting";
import Watch from "./screens/watch/Watch";
import ArchivedGames from "./screens/ArchivedGames";
import AcceptEditorAuth from "./screens/AcceptEditorAuth";
import ImportGamepack from "./screens/operate/ImportGamepack";
import MakeGamePack from "./screens/admin/MakeGamePack";
import ErrorBoundary from "./screens/components/ErrorBoundary";

//ログイン不要のページ（コンポーネント外の定数のため依存配列に含める必要がない）
const noAuthPages = ['/signIn', '/signUp', '/info', '/info/terms', '/info/privacy', '/info/notations_sct'];

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  //ユーザーデータの利用
  const [userData, setUserData] = useState({loading: true});

  //認証状態の監視クロージャ内から常に最新のlocationを参照するためのref
  const locationRef = useRef(location);
  useEffect(() => {
    locationRef.current = location;
  }, [location]);

  useEffect(() => {
    //ユーザーデータ取得用リスナーの解除関数
    let unsubscribeUser = null;

    //ログイン状態の監視
    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      //ユーザーが切り替わったら、前のユーザーデータ監視を解除
      if(unsubscribeUser) {
        unsubscribeUser();
        unsubscribeUser = null;
      }

      if(user) {
        //ユーザーデータを取得
        const userRef = ref(db, 'users/' + user.uid);
        unsubscribeUser = onValue(userRef, (snapshot) => {
          const data = snapshot.val();

          get(ref(db, 'userCoins/' + user.uid)).then((snapshotCoin) => {
            setUserData({
              uid: user.uid,
              email: user.email,
              verified: user.emailVerified,
              ...data,
              coin: snapshotCoin.exists() ? snapshotCoin.val().coin : 0
            });
          })
        });
      } else {
        setUserData({});
        if(!noAuthPages.includes(locationRef.current.pathname)) {
          navigate('/signIn');
        }
      }
    });

    return () => {
      if(unsubscribeUser) unsubscribeUser();
      unsubscribeAuth();
    };
  }, [navigate]);


  return (
    <div className="">
      <Header userData={userData} />

      {/* 想定外のエラーで画面が真っ白になるのを防ぐため、各画面をエラーバウンダリで保護する。
          key にパスを指定することで、別画面へ遷移すればエラー状態がリセットされる。 */}
      <ErrorBoundary key={location.pathname}>
      <Routes>
        <Route path="/" element={<Home userData={userData} />}/>
        <Route path="/archive" element={<ArchivedGames userData={userData} />}/>
        <Route path="/info" element={<Info />}/>
        <Route path="/info/privacy" element={<Privacy />}/>
        <Route path="/info/terms" element={<Terms />}/>
        <Route path="/info/notations_sct" element={<NotationsSCT />}/>
        
        <Route path="/signIn" element={<SignIn />}/>
        <Route path="/signUp" element={<SignUp />}/>
        <Route path="/account" element={<Account userData={userData} />}/>
        <Route path="/account/setting" element={<Setting userData={userData} />}/>
        <Route path="/account/achievement" element={<JoinHistory userData={userData} />}/>
        <Route path="/account/addCoin" element={<AddCoin userData={userData} />}/>
        <Route path="/account/addCoin/history" element={<CoinHistory userData={userData} />}/>

        <Route path="/join" element={<Join userData={userData} />}/>
        <Route path="/watch" element={<Watch userData={userData} />}/>
        <Route path="/acceptEditorAuth" element={<AcceptEditorAuth userData={userData} />}/>

        <Route path="/game" element={<GameHome userData={userData} />}/>
        <Route path="/game/map" element={<MapPage userData={userData} />}/>
        <Route path="/game/missions" element={<Missions userData={userData} />}/>
        <Route path="/game/missions/submit" element={<SubmitMission userData={userData} />}/>
        <Route path="/game/missions/view" element={<MissionReport userData={userData} />}/>
        <Route path="/game/catch" element={<Catch userData={userData} />}/>
        <Route path="/game/allTeam" element={<TeamList userData={userData} />}/>
        <Route path="/game/history" element={<HistoryPage userData={userData} />}/>
        <Route path="/game/specialItems" element={<SpecialItems userData={userData} />}/>

        <Route path="/edit" element={<EditGame userData={userData} />}/>
        <Route path="/control" element={<Control userData={userData} />}/>
        <Route path="/importPack" element={<ImportGamepack userData={userData} />}/>

        <Route path="/admin/makepack" element={<MakeGamePack userData={userData} />}/>
      </Routes>
      </ErrorBoundary>

      <Footer />
    </div>
  );
}

export default App;
